import Monogram from "@/components/Monogram";
import { scrollToSection } from "@/lib/scroll";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 py-12">
      <div className="wrap flex flex-col items-center justify-between gap-8 sm:flex-row">
        <div className="flex items-center gap-3">
          <Monogram className="h-8 w-8" />
          <div>
            <p className="font-display text-sm font-bold uppercase tracking-[0.2em]">Ayan Jafri</p>
            <p className="mono-label mt-1 text-[9px] text-zinc-600">Video Editor &amp; Motion Designer</p>
          </div>
        </div>
        <nav className="flex items-center gap-7">
          {[
            { label: "Work", href: "#work", id: "footer-link-work" },
            { label: "Services", href: "#services", id: "footer-link-services" },
            { label: "Clients", href: "#clients", id: "footer-link-clients" },
            { label: "Contact", href: "#contact", id: "footer-link-contact" },
          ].map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.id}
              onClick={(e) => {
                e.preventDefault();
                scrollToSection(l.href);
              }}
              className="mono-label text-[9px] text-zinc-500 transition-colors hover:text-white"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <p className="mono-label text-[9px] text-zinc-600">© {new Date().getFullYear()} Ayan Jafri</p>
      </div>
    </footer>
  );
}
